module.exports = __webpack_public_path__ + "media/images/action_archive-b569f86786d57e2e97092b44c7e547e0.png";